import React from 'react';

import { IconButton } from '@iris/react-components';
import { SparklesIcon } from '@iris/react-icons';

import { useDevice } from '@bonnet/next/device';

import { sendClick } from 'reaxl-analytics';

import { shoppingAssistantIconClick } from '@/analytics/shoppingAssistantEvents';

import ShoppingAssistantPopover from './ShoppingAssistantPopover';

function ShoppingAssistantContainer({
    handleAssistantClose,
    headingText,
    setShowAssistant,
    showAssistant,
    showChatDialog = false,
    suggestedActions,
}) {
    const device = useDevice();
    const isXs = device?.is?.xs;

    const handleAssistantClick = (event) => {
        sendClick(shoppingAssistantIconClick, event, {});
        setShowAssistant((prev) => !prev);
    };

    const triggerButton = (
        <IconButton
            aria-label="Open Shopping Assistant"
            className="iris:py-2 iris:px-2"
            icon={<SparklesIcon className="iris:p-0" />}
            id="shopping-assistant-entry"
            inverse
            onClick={handleAssistantClick}
            size="md"
            style={{ bottom: isXs ? 70 : 100 }}
        />
    );

    return (
        <div className="shopping-assistant">
            <ShoppingAssistantPopover
                containerElement={{ offsetWidth: 400 }}
                handleAssistantClose={handleAssistantClose}
                headingText={headingText}
                show={showAssistant}
                showChatDialog={showChatDialog}
                suggestedActions={suggestedActions}
                trigger={triggerButton}
            />
        </div>
    );
}

export default ShoppingAssistantContainer;
